// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Menu Component */
/**
 * Base Styles/Mixins for Ids Menu Component and all subcomponents.
 */
:host {
  display: block;
}

.ids-menu {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-menu/ids-menu.scss","webpack://./src/components/ids-menu/ids-menu-base.scss"],"names":[],"mappings":"AAAA,uBAAA;ACAA;;EAAA;ADGA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF","sourcesContent":["/* Ids Menu Component */\n@use './ids-menu-base' as *;\n\n:host {\n  display: block;\n}\n\n.ids-menu {\n  display: block;\n}\n","/**\n * Base Styles/Mixins for Ids Menu Component and all subcomponents.\n */\n// Resets the User-Agent stylesheet rules for `<ul>` in Chrome\n@mixin reset-menu-style() {\n  display: block;\n  margin-block-end: 0;\n  margin-block-start: 0;\n  padding-inline-start: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
